export const hasGroup = (user, groupName) => {
    if (!user || !user.groups) {
        return false;
    }
    return user.groups.includes(groupName);
};
